<div class="mat-typography skipped-days-container">
    <p class="skipped-days-description"
       translate>
        skipped_days_settings_description
    </p>
    <p *ngIf="isMultipleCalendarsEnabled"
       class="skipped-days-description">
        {{ 'skipped_days_settings_description_learn_more' | translate }}:
        <a rel="noopener noreferrer"
           href="https://docs.uipath.com/orchestrator/v2019/docs/managing-triggers"
           target="_blank">
            https://docs.uipath.com/orchestrator/v2019/docs/managing-triggers
        </a>
    </p>

    <div *ngLet="!!calendars?.length && calendars[0].newEntry as newEntry"
         class="layout-row layout-wrap">
        <div *ngIf="isMultipleCalendarsEnabled"
             class="skipped-days-calendar-name">
            <div class="skipped-days-add-new">
                <label [matTooltip]="'skipped_days_calendar_label' | translate"
                       translate>skipped_days_calendar_label</label>
                <button [uiAuthorizeDisable]="'Settings.Create'"
                        [disableIf]="newEntry"
                        [uiClickTrack]="'Settings: Calendar: Add'"
                        [matTooltip]="'skipped_days_calendar_add' | translate"
                        (click)="createCalendarEntry()"
                        type="button"
                        mat-mini-fab
                        class="skipped-days-add-button"
                        data-cy="skipped-days-add">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
            <mat-list class="skipped-days-calendar-list">
                <ui-skipped-days-calendar-item #calendarItems
                                               *ngFor="let c of calendars let i = index; trackBy: trackById"
                                               [calendar]="c"
                                               [isSelected]="i === selected"
                                               (click)="onSelect(i)"
                                               (focus)="onSelect(i)"
                                               (calendarSaved)="onSave($event)"
                                               data-cy="calendar-item">
                </ui-skipped-days-calendar-item>
            </mat-list>
        </div>

        <div *ngIf="calendars?.length"
             class="skipped-days-calendar-container">
            <div class="skipped-days-calendar"
                 [formGroup]="formGroup">
                <ng-container *ngIf="isMultipleCalendarsEnabled; else calendar">
                    <div *ngIf="loadingFile$ | async"
                         class="loading-filter">
                        <p translate>skipped_days_calendar_uploading</p>
                    </div>
                    <div uiDragAndDropFile
                         [fileBrowseRef]="browseTrigger"
                         [multiple]="false"
                         (fileChange)="onFileChange($event)"
                         fileType=".csv"
                         data-cy="skipped-days-upload-container">
                        <div class="layout-row upload-csv">
                            <span translate>
                                skipped_days_calendar_upload_text
                            </span>
                            <label #browseTrigger>
                                <button [uiAuthorizeDisable]="calendarPermissions"
                                        [disableIf]="(loadingFile$ | async) || (loading$ | async)"
                                        [matTooltip]="dateFormatTooltip"
                                        matTooltipClass="tooltip-linebreak"
                                        mat-button
                                        color="primary"
                                        type="button"
                                        class="ui-upload-button">
                                    <mat-icon>cloud_upload</mat-icon>
                                    <span translate
                                          class="text-upper">
                                        skipped_days_calendar_upload_button
                                    </span>
                                </button>
                            </label>
                        </div>
                    </div>
                    <ng-container [ngTemplateOutlet]="calendar"></ng-container>
                    <div *ngLet="(loading$ | async) as loading"
                         class="calendar-button-bar">
                        <button [uiAuthorizeDisable]="'Settings.Delete'"
                                [disableIf]="loading"
                                (click)="onDelete()"
                                mat-button
                                color="warn"
                                class="delete-button"
                                type="button"
                                data-cy="calendar-delete-button">
                            {{ 'modal_action_delete' | translate }}
                        </button>
                        <button [uiAuthorizeDisable]="calendarPermissions"
                                [disableIf]="(!formGroup.dirty && !selectedCalendarItem?.formGroup.dirty)
                                                    || selectedCalendarItem?.formGroup.invalid
                                                    || loading"
                                [spinnerButtonLoading]="loading"
                                (click)="onSave(selectedCalendar)"
                                ui-spinner-button
                                mat-flat-button
                                color="primary"
                                class="save-button"
                                type="button"
                                data-cy="calendar-save-button">
                            {{ 'modal_action_save' | translate }}
                        </button>
                    </div>
                </ng-container>
                <ng-template #calendar>
                    <ui-calendar #calendarComponent
                                 [uiAuthorizeDisable]="calendarPermissions"
                                 [minMonthDate]="today"
                                 [disableIf]="loading$ | async"
                                 formControlName="date">
                    </ui-calendar>
                </ng-template>
            </div>
        </div>
    </div>
</div>
